import { render } from "./KnowhowTip8.vue?vue&type=template&id=1e67419d"
import script from "./KnowhowTip8.vue?vue&type=script&lang=js"
export * from "./KnowhowTip8.vue?vue&type=script&lang=js"

import "./KnowhowTip8.vue?vue&type=style&index=0&id=1e67419d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__